/* eslint-disable consistent-return */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import {
  call, put, takeLatest, all
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions, actionCreators } from 'react/api/actions/samlConfiguration';
import { actionCreators as wizardActionCreator } from 'react/api/actions/wizard';
import { getResourceTo } from 'react/utils/utils';
import { change } from 'redux-form';

function* fetchtMappingsModels(initialModel, entity) {
  const { defaultValue } = initialModel;

  if (!defaultValue) {
    return;
  }

  const projection = JSON.stringify({
    filters: [
      'id',
      'key',
      'description'
    ],
    firstResult: 0,
    maxResults: 51
  });

  const criteria = {
    criteriaChain: [
      {
        and: [
          {
            attr: 'id',
            eq: defaultValue
          }
        ]
      }
    ]
  };

  const encodedURL = encodeURI(`/${entity}/restrictions?criteria=${projection}`);
  const mappingResponse = yield call(defaultFetch, encodedURL, criteria, 'POST');

  const {
    id,
    description,
    key
  } = mappingResponse[0];

  const mappingModel = {};

  if (description) {
    Object.assign(mappingModel,
      {
        id: `${id}`,
        description,
        model: mappingResponse[0]
      });
  } else {
    Object.assign(mappingModel,
      {
        id: `${id}`,
        description: key,
        name: key,
        model: mappingResponse[0]
      });
  }

  // eslint-disable-next-line consistent-return
  return mappingModel;
}

function* fetchtExtraMappingsModels(initialModel, entity) {
  if (initialModel === null) {
    return;
  }

  const objectMapping = [];

  for (const name in initialModel) {
    const idToSearch = initialModel[name];

    const projection = JSON.stringify({
      filters: [
        'id',
        'key',
        'description'
      ],
      firstResult: 0,
      maxResults: 51
    });

    const criteria = {
      criteriaChain: [
        {
          and: [
            {
              attr: 'id',
              eq: idToSearch
            }
          ]
        }
      ]
    };

    const encodedURL = encodeURI(`/${entity}/restrictions?criteria=${projection}`);
    const response = yield call(defaultFetch, encodedURL, criteria, 'POST');

    const {
      id,
      description
    } = response[0];

    objectMapping.push({
      assertionFieldName: name,
      value: {
        id,
        description,
        model: response
      }
    });
  }

  return objectMapping;
}

// eslint-disable-next-line require-yield
function* fetchtGroupMappingsModels(initialModel, entity) {
  if (initialModel === null) {
    return;
  }

  const objectMapping = [];

  for (const name in initialModel) {
    const idsArray = [];

    idsArray.push(...initialModel[name]);

    const projection = JSON.stringify({
      filters: [
        'id',
        'key',
        'description'
      ],
      firstResult: 0,
      maxResults: 51
    });

    const criteria = {
      criteriaChain: [
        {
          and: [
            {
              attr: 'id',
              in: idsArray
            }
          ]
        }
      ]
    };

    const encodedURL = encodeURI(`/${entity}/restrictions?criteria=${projection}`);
    const response = yield call(defaultFetch, encodedURL, criteria, 'POST');

    const valuesArray = response.map((item) => {
      const { id, key } = item;

      return { id, name: key };
    });

    objectMapping.push({ assertionFieldName: name, value: valuesArray });
  }

  return objectMapping;
}

function* fetchInitialFormValuesApi(url) {
  const encodedUrl = encodeURI(url);
  return yield call(defaultFetch, encodedUrl);
}

function* fetchInitialFormSaga(action) {
  const { samlIdpURL, entity } = action.payload;
  yield put(wizardActionCreator.fetchInitialFormValues({ entity }));
  const response = yield call(fetchInitialFormValuesApi, samlIdpURL);
  const { error } = response;

  if (!error) {
    const {
      idp: {
        fieldMappings: {
          userOrganizationKey,
          userI18nLocaleKey,
          userGroups
        },
        organizationMappings,
        groupMappings,
        tagMappings,
        i18nLocaleMappings
      }
    } = response;

    yield put(wizardActionCreator.fetchInitialFormValuesSuccess({ values: response, entity }));

    const organizationMapping = yield call(fetchtMappingsModels, userOrganizationKey, 'Organization');
    const localeKeyMapping = yield call(fetchtMappingsModels, userI18nLocaleKey, 'I18NLocale');
    const groupsMapping = yield call(fetchtMappingsModels, userGroups, 'Group');
    const extraGroupMappings = yield call(fetchtGroupMappingsModels, groupMappings, 'Group');
    const extraOrganizationMappings = yield call(fetchtExtraMappingsModels, organizationMappings, 'Organization');
    const extraTagMappings = yield call(fetchtExtraMappingsModels, tagMappings, 'Tag');
    const extraLocaleMappings = yield call(fetchtExtraMappingsModels, i18nLocaleMappings, 'I18NLocale');

    if (organizationMapping) {
      yield put(change('SamlConfiguration', 'idp.fieldMappings.userOrganizationKey.defaultValue', organizationMapping));
    }

    if (localeKeyMapping) {
      yield put(change('SamlConfiguration', 'idp.fieldMappings.userI18nLocaleKey.defaultValue', localeKeyMapping));
    }

    if (groupsMapping) {
      yield put(change('SamlConfiguration', 'idp.fieldMappings.userGroups.defaultValue', groupsMapping));
    }

    if (extraGroupMappings) {
      yield put(change('SamlConfiguration', 'idp.groupMappings', extraGroupMappings));
    }

    if (extraOrganizationMappings) {
      yield put(change('SamlConfiguration', 'idp.organizationMappings', extraOrganizationMappings));
    }

    if (extraTagMappings) {
      yield put(change('SamlConfiguration', 'idp.tagMappings', extraTagMappings));
    }

    if (extraLocaleMappings) {
      yield put(change('SamlConfiguration', 'idp.i18nLocaleMappings', extraLocaleMappings));
    }
  } else {
    yield put(wizardActionCreator.saveFormError({ entity: 'SamlConfiguration', customError: error.message }));
  }
}

function* validateUrl(action) {
  const { idpURL } = action.payload;
  const tenant = Greenmile.Utils.getTenant();
  const url = `/saml/processURLMetadata?url=${idpURL}&tenant=${tenant}`;

  if (!idpURL) {
    return;
  }

  const response = yield call(defaultFetch, url, {}, 'GET', false);

  if (response.status === 200) {
    const certificate = yield call(() => response.text() || []);

    yield put(actionCreators.confirmIdpUrlValidation());
    yield put(change('SamlConfiguration', 'idpCertificate', certificate));
  } else {
    const { error } = response.error;

    if (error === 'Precondition Required') {
      const isInvalidResource = getResourceTo('samlConfiguration.metadataSection.isInvalid');

      yield put(change('SamlConfiguration', 'idpCertificate', ''));
      yield put(actionCreators.denyIdpUrlValidation({ error: isInvalidResource }));
    } else {
      yield put(actionCreators.denyIdpUrlValidation({ error: 'Server error' }));
    }
  }
}

export function* saveFormApi(data) {
  const encodedUrl = encodeURI('/saml/idp');
  const tenant = Greenmile.Utils.getTenant();

  data.idp.tenant = tenant;
  data.idp.idpProtocol = 'SAML';

  return yield call(defaultFetch, encodedUrl, data, 'PUT');
}

const optmizeLookupFieldMappingValues = (valueName, values, value) => {
  if (typeof value.defaultValue === 'object') {
    const {
      assertionFieldName,
      defaultValue: {
        model: {
          id
        }
      }
    } = value;

    const valueMapping = {
      assertionFieldName,
      defaultValue: id ? id : ''
    };

    Object.assign(values.idp.fieldMappings[valueName], valueMapping);
  }
};

const optmizeExtraLookupFieldMappingValues = (
  initialState,
  values,
  valueName
) => {
  let optimizedObject;

  if (valueName === 'groupMappings') {
    optimizedObject = initialState.reduce((acc, currrent) => {
      const providerValue = currrent.assertionFieldName;
      const idArray = currrent.value.map(((value) => parseInt(value.id, 10)));

      return {
        ...acc,
        [providerValue]: idArray
      };
    }, {});
  } else {
    optimizedObject = initialState.reduce((acc, currrent) => {
      const providerValue = currrent.assertionFieldName;
      return {
        ...acc,
        [providerValue]: parseInt(currrent.value.id, 10)
      };
    }, {});
  }

  // eslint-disable-next-line no-param-reassign
  values.idp[valueName] = optimizedObject;
};

const mapValuesToSave = (values) => {

  const {
    idp: {
      fieldMappings,
      organizationMappings,
      groupMappings,
      tagMappings,
      i18nLocaleMappings
    }
  } = values;

  if (fieldMappings.userOrganizationKey) {
    optmizeLookupFieldMappingValues('userOrganizationKey', values, fieldMappings.userOrganizationKey);
  }

  if (fieldMappings.userI18nLocaleKey) {
    optmizeLookupFieldMappingValues('userI18nLocaleKey', values, fieldMappings.userI18nLocaleKey);
  }

  if (fieldMappings.userGroups) {
    optmizeLookupFieldMappingValues('userGroups', values, fieldMappings.userGroups);
  }

  if (Array.isArray(organizationMappings) && organizationMappings.length) {
    optmizeExtraLookupFieldMappingValues(
      organizationMappings,
      values,
      'organizationMappings',
      'providerNameOrganization',
      'greenMileOrganizationValue'
    );
  }

  if (Array.isArray(groupMappings)) {
    optmizeExtraLookupFieldMappingValues(
      groupMappings,
      values,
      'groupMappings',
      'sku',
      'greenMileGroupValue'
    );
  }

  if (Array.isArray(tagMappings)) {
    optmizeExtraLookupFieldMappingValues(
      tagMappings,
      values,
      'tagMappings',
      'userTag',
      'greenMileUserTagValue'
    );
  }

  if (Array.isArray(i18nLocaleMappings)) {
    optmizeExtraLookupFieldMappingValues(
      i18nLocaleMappings,
      values,
      'i18nLocaleMappings',
      'providerNameLocale',
      'greenMileLocaleValue'
    );
  }
  return values;
};

function* saveFormSaga(action) {
  const { data, goToGrid } = action.payload;
  const response = yield call(saveFormApi, mapValuesToSave(JSON.parse(JSON.stringify(data))));
  const { error } = response;
  if (!error) {
    yield put(wizardActionCreator.saveFormSuccess({ entity: 'SamlConfiguration' }));
    goToGrid();
  } else {
    yield put(wizardActionCreator.saveFormError({
      entity: 'SamlConfiguration',
      customError: error.message
    }));
  }
}

function* watchIdentityProviderUrlValidation() {
  yield takeLatest(actions.initializeIdpUrlValidation, validateUrl);
}

function* watchSaveForm() {
  yield takeLatest(actions.saveForm, saveFormSaga);
}

function* watchFetchInitialFormValues() {
  yield takeLatest(actions.fetchInitialFormValues, fetchInitialFormSaga);
}

export default function* () {
  yield all([
    watchIdentityProviderUrlValidation(),
    watchSaveForm(),
    watchFetchInitialFormValues()
  ]);
}
